<template>
    <div class="phone-input-box">
        <multiselect v-model="selectValue"
                     label="prefix"
                     track-by="prefix"
                     placeholder="+38"
                     class="multiselect-phone"
                     :allow-empty="false"
                     deselectLabel=""
                     :class="{ invalid: field.error }"
                     :options="options"
                     :option-height="104"
                     :searchable="false"
                     :show-labels="false">
            <template slot="singleLabel" slot-scope="props"><img class="option__image" :src="props.option.img" alt="No Man’s Sky"><span class="option__desc"><span class="option__title">{{ props.option.prefix }}</span></span></template>
            <template slot="option" slot-scope="props">
                <div class="d-flex align-items-center">
                    <img class="option__image" :src="props.option.img" alt="No Man’s Sky">
                    <div class="option__desc">{{ props.option.prefix }}</div>
                </div>
            </template>
        </multiselect>
        <input
                id="phoneNumber"
                type="text"
                class="form-control phone-input"
                :class="{'is-invalid': field.error}"
                :name="field.name.toLowerCase()"
                :placeholder="field.placeholder"
                v-model="phoneNumber"
        />
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    export default {
        name: "phoneSelect",
        props: ['value', 'field'],
        data () {
            return {
                selectValue: { prefix: '+381', img: require("@/assets/images/flags/serbia.png") },
                options: [
                    { prefix: '+381', img: require("@/assets/images/flags/serbia.png") },
                    { prefix: '+387', img: require("@/assets/images/flags/bosnia-and-herzegovina.png") },
                    { prefix: '+385', img: require("@/assets/images/flags/croatia.png") },
                    { prefix: '+386', img: require("@/assets/images/flags/slovenia.png") },
                    { prefix: '+382', img: require("@/assets/images/flags/montenegro.png") },
                    { prefix: '+389', img: require("@/assets/images/flags/macedonia.png") },
                ],
                phoneNumber: ''
            };
        },
        watch: {
            value() {
              this.updatePrefix();
            },
            selectValue () {
                this.updateValue();
            },
            phoneNumber () {
                this.updateValue();
            }
        },
        created () {
          this.updatePrefix()
        },
        components: {
            Multiselect
        },
        methods: {
            updatePrefix() {
              this.options.forEach(option => {
                if (option.prefix === this.value.slice(0,4)) {
                  this.selectValue = option;
                }
              });
              this.phoneNumber = this.value.slice(4);
            },
            updateValue () {
                if (this.selectValue) {
                    this.$emit('input', this.selectValue.prefix + this.phoneNumber)
                } else {
                    this.$emit('input', this.phoneNumber)
                }
            }
        }
    }
</script>

<style scoped>
    .option__image {
        width: 20px;
        margin-right: 5px;
    }
    .phone-input-box {
        display: flex;
    }
    .multiselect-phone {
        max-width: 90px;
    }
    .phone-input {
        height: 38px;
        margin-left: 5px;
    }
</style>
